"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateRevokeRequest = exports.CertificatePatchRequest = exports.CertificateUploadRequest = exports.CertificateSummary = exports.CertificateStatus = void 0;
const zod_1 = require("zod");
/**
 * Generic fiscal / signing certificate lifecycle (Sprint 12,
 * folded from dropped Sprint 11). No UA / PRRO content — the
 * `kind` field is free-form so any future cert (LT-VMI signing,
 * UA-PRRO key, internal CA chain, etc.) fits the same shape.
 *
 * **Encryption.** The cleartext `payload` is pgp_sym_encrypted
 * application-side before insert; the row carries the encrypted
 * bytea plus a SHA-256 of the cleartext for "same cert" diffs
 * without decrypt. The decryption key is supplied via the
 * `CERT_ENCRYPTION_KEY` env var — never persisted alongside the
 * ciphertext.
 *
 * **Bound scope.** Each cert is optionally bound to a single
 * `terminalProfileId`. Unbound (`null`) certs are global / library
 * entries the admin can later attach.
 */
exports.CertificateStatus = zod_1.z.enum(['active', 'revoked', 'expired']);
exports.CertificateSummary = zod_1.z.object({
    id: zod_1.z.string(),
    label: zod_1.z.string(),
    kind: zod_1.z.string(),
    terminalProfileId: zod_1.z.string().nullable(),
    status: exports.CertificateStatus,
    serialNumber: zod_1.z.string().nullable(),
    notBefore: zod_1.z.string().datetime().nullable(),
    notAfter: zod_1.z.string().datetime().nullable(),
    payloadSha256: zod_1.z.string(),
    revokedAt: zod_1.z.string().datetime().nullable(),
    revokedReason: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.CertificateUploadRequest = zod_1.z
    .object({
    label: zod_1.z.string().min(1).max(255),
    kind: zod_1.z.string().min(1).max(64),
    terminalProfileId: zod_1.z.string().nullable().optional(),
    serialNumber: zod_1.z.string().max(255).nullable().optional(),
    notBefore: zod_1.z.string().datetime().nullable().optional(),
    notAfter: zod_1.z.string().datetime().nullable().optional(),
    /** Base64-encoded payload (PEM, PFX, etc.). Encrypted at rest. */
    payloadBase64: zod_1.z.string().min(1).max(2_000_000),
})
    .strict();
/**
 * PATCH body — narrow on purpose. Rotating the actual key
 * payload requires a fresh upload (audit-clean); this endpoint
 * only touches the binding + metadata.
 */
exports.CertificatePatchRequest = zod_1.z
    .object({
    label: zod_1.z.string().min(1).max(255).optional(),
    terminalProfileId: zod_1.z.string().nullable().optional(),
    serialNumber: zod_1.z.string().max(255).nullable().optional(),
    notBefore: zod_1.z.string().datetime().nullable().optional(),
    notAfter: zod_1.z.string().datetime().nullable().optional(),
})
    .strict();
exports.CertificateRevokeRequest = zod_1.z
    .object({
    reason: zod_1.z.string().min(1).max(500),
})
    .strict();
//# sourceMappingURL=certificates.js.map